export const fieldMapper = (
  fieldMappings = [],
  fund = "",
  customInputs = [],
  products = []
) => {
  const result = {};
  fieldMappings.forEach((mapping) => {
    const {
      charityStackLabel,
      charityStackParentValue,
      charityStackValue,
      integrationLabel,
      integrationValue,
      integrationType,
    } = mapping;

    const key = `${integrationType}_${integrationLabel}`;
    if (charityStackLabel === "Funds") {
      if (charityStackValue === fund) {
        result[key] = integrationValue;
      }
    } else if (charityStackLabel === "Sponsorship Options") {
      // see if any product in products has a matching
      // productName for charityStackValue and charityStackParentValue for productGroupName
      const product = products.find(
        (product) =>
          product.productName === charityStackValue &&
          product.productGroupName === charityStackParentValue
      );
      if (product) {
        result[key] = integrationValue;
      }
    } else if (charityStackLabel === "Custom Inputs") {
      // see if any customInput in customInputs has a matching
      // customInputTitle for charityStackValue
      const customInput = customInputs.find(
        (customInput) =>
          (customInput.type === "SINGLE_SELECTION_DROPDOWN" &&
            customInput.title === charityStackParentValue &&
            customInput.answers?.[0] === charityStackValue) ||
          (customInput.type === "SHORT_TEXT_INPUT" &&
            customInput.title === charityStackParentValue) ||
          (customInput.type === "LONG_TEXT_INPUT" &&
            customInput.title === charityStackParentValue)
      );
      if (customInput) {
        result[key] = integrationValue;
      }
    }
  });

  return result;
};
